import api from './api';

/**
 * Facturador electrónico (/api/facturador)
 * Usado por las pantallas de /facturador del panel del cliente.
 */

const deEmpresa = (idCompany, extra = {}) => ({ params: { id_company: idCompany, ...extra } });

/** Identificador de cada envío de un formulario: un doble clic no emite dos veces. */
export const nuevoIdPeticion = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `panel-${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const getEstado = (idCompany) =>
  api.get('/api/facturador/estado', deEmpresa(idCompany)).then(r => r.data);

// ── Configuración ─────────────────────────────────────────────────────────────

export const getEmisor = (idCompany) =>
  api.get('/api/facturador/emisor', deEmpresa(idCompany)).then(r => r.data);

export const guardarEmisor = (idCompany, datos) =>
  api.put('/api/facturador/emisor', { id_company: idCompany, ...datos }).then(r => r.data);

export const getCertificado = (idCompany) =>
  api.get('/api/facturador/certificado', deEmpresa(idCompany)).then(r => r.data);

export const subirCertificado = (idCompany, archivo, clave) => {
  const formData = new FormData();
  formData.append('archivo', archivo);
  formData.append('clave', clave);
  formData.append('id_company', idCompany);
  return api.post('/api/facturador/certificado', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};

export const getFolios = (idCompany) =>
  api.get('/api/facturador/folios', deEmpresa(idCompany)).then(r => r.data);

export const subirFolios = (idCompany, archivo) => {
  const formData = new FormData();
  formData.append('archivo', archivo);
  formData.append('id_company', idCompany);
  return api.post('/api/facturador/folios', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};

// ── Documentos ────────────────────────────────────────────────────────────────

export const buscarReceptores = (idCompany, texto) =>
  api.get('/api/facturador/receptores', deEmpresa(idCompany, { q: texto })).then(r => r.data);

export const previsualizar = (idCompany, { tipo, lineas, montosConIva }) =>
  api.post('/api/facturador/documentos/previsualizar', { id_company: idCompany, tipo, lineas, montosConIva })
    .then(r => r.data);

export const emitir = (idCompany, solicitud, idPeticion) =>
  api.post('/api/facturador/documentos', { id_company: idCompany, ...solicitud }, {
    headers: { 'Idempotency-Key': idPeticion }
  }).then(r => r.data);

export const getDocumentos = (idCompany, filtros = {}) =>
  api.get('/api/facturador/documentos', deEmpresa(idCompany, filtros)).then(r => r.data);

export const getDocumento = (idCompany, id) =>
  api.get(`/api/facturador/documentos/${id}`, deEmpresa(idCompany)).then(r => r.data);

export const anular = (idCompany, id, razon, idPeticion) =>
  api.post(`/api/facturador/documentos/${id}/anular`, { id_company: idCompany, razon }, {
    headers: { 'Idempotency-Key': idPeticion }
  }).then(r => r.data);

export const corregir = (idCompany, id, correccion, razon, idPeticion) =>
  api.post(`/api/facturador/documentos/${id}/corregir`, { id_company: idCompany, correccion, razon }, {
    headers: { 'Idempotency-Key': idPeticion }
  }).then(r => r.data);
